import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { UsePostsContext } from "../../store/contexts/posts.context";
import Container from "../../UI/Container";
import CategoryColumn from "../Home/CategoryColumn";
import ProfileInfo from "./ProfileInfo";

function UserProfile() {
  const params = useParams();
  const { getUser, getUserPosts } = UsePostsContext();
  const [user, setuser] = useState();
  const [posts, setposts] = useState([]);
  const [pag, setpag] = useState();
  useEffect(() => {
    setpag(0);
  }, []);
  useEffect(() => {
    if (params.id && pag !== null) {
      (async () => {
        const res = await getUser(params.id);
        setuser(res.data);
        const posts = await getUserPosts(pag, 6, params.id);
        setposts(posts.data);
      })();
    }
  }, [pag]);

  return (
    <Container>
      <h1 className="main-title flex start">
        <div className="flex start">
          Published by Author
          <div className="tag post-count" style={{ marginLeft: "10px" }}>
            <h1>{posts?.length ? posts.length : 0}</h1>
          </div>
        </div>
      </h1>
      <div className="devider"></div>
      <ProfileInfo userData={user} />
      <div className="devider"></div>
      <CategoryColumn data={posts} title="Posts" add={" "} />
      <div className="devider"></div>
      <Pagination className="flex">
        <div
          onClick={() => setpag(pag === 0 ? 0 : pag - 6)}
          style={{ opacity: pag === 0 ? "0.4" : "1" }}
        >
          <img src="https://img.icons8.com/external-dreamstale-lineal-dreamstale/32/undefined/external-left-arrows-dreamstale-lineal-dreamstale-10.png" />
          <span>Prev</span>
        </div>
        <div
          onClick={() => setpag(posts?.length === 6 ? pag + 6 : pag)}
          style={{ opacity: posts?.length === 6 ? "1" : "0.4" }}
        >
          <span>Next</span>
          <img src="https://img.icons8.com/external-dreamstale-lineal-dreamstale/32/undefined/external-right-arrows-dreamstale-lineal-dreamstale-8.png" />
        </div>
      </Pagination>
      <div className="devider"></div>
    </Container>
  );
}

export default UserProfile;
const Wrapper = styled.div``;
const Pagination = styled.div`
  gap: 40px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
      span {
        width: 50px;
      }
    }
    img {
      transition: all 0.3s;
    }
    span {
      transition: all 0.3s;
      display: block;
      width: 0px;
      overflow: hidden;
    }
  }
  img {
    width: 20px !important;
    height: 20px !important;
  }
`;
